import { Spin } from "antd";
import React from "react";

const ChartLoader = () => {
  return (
    <div className="h-full w-full flex justify-center items-center">
      <div className="w-full">
        <Spin
          tip="Getting insights"
          size="large"
          className="w-full h-full flex items-center justify-center"
        >
          <div />
        </Spin>
      </div>
    </div>
  );
};

export default ChartLoader;
